export const reverbConfig = {
  key: process.env.REVERB_APP_KEY as string,
  wsHost: process.env.REVERB_HOST as string,
  wsPort: parseInt(process.env.REVERB_PORT || '8080', 10),
  scheme: process.env.REVERB_SCHEME || 'http',
};
